var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUrgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.124,
    height: 46.567,
    viewBox: "0 0 58.124 46.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "urgent",
    transform: "translate(0 -44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M82.107,134.073h4.009V118.039H77.1l-2-3.006V103.006h8.017l-1-3.006H68.077v26.056H32v8.017h4.009",
    transform: "translate(-27.991 -48.985)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(8.313 78.79)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(34.75 1.777)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(-0.25 1.777)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(11.75 1.777)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M383.015,124l4.009,15.032H378l-2-3.006V124Z",
    transform: "translate(-328.899 -69.979)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(46.062 83.566)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(11.024 84.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M186,368.009a2,2,0,1,1,2-2A2,2,0,0,1,186,368.009Z",
    transform: "translate(-171.974 -364)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M90,368.009a2,2,0,1,1,2-2A2,2,0,0,1,90,368.009Z",
    transform: "translate(-88 -364)",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M4.009,308H0v4.009H4.009",
    transform: "translate(0 -230.929)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M424,268h5.011v5.011H424Z",
    transform: "translate(-370.886 -195.94)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M16,50.843V44H54.081V77.071H16V50.843Z",
    transform: "translate(-13.996 0)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(13.028 54.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M109.011,124H105a1,1,0,0,0-1,1v1.8a1,1,0,1,0,2,0V126h2v2.072l-3.568,2.405a1,1,0,0,0-.441.834v2.706a1,1,0,0,0,1,1h4.009a1,1,0,0,0,0-2H106v-1.172l3.568-2.405a1,1,0,0,0,.441-.833V125a1,1,0,0,0-1-1Z",
    transform: "translate(-104 -124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M167.015,130.013h-1v-3.006a1,1,0,1,0-2,0v3.006h-2V125a1,1,0,0,0-2,0v6.013a1,1,0,0,0,1,1h3.006v2a1,1,0,0,0,2,0v-2h1a1,1,0,1,0,0-2Z",
    transform: "translate(-152.985 -124)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M75.48,76a11.525,11.525,0,0,0-.554,23.036h.035c.09,0,.328,0,.611.006l-.3.3a1,1,0,1,0,1.392,1.442l.025-.025,2-2a1.011,1.011,0,0,0,.218-.328.994.994,0,0,0,.068-.337c0-.016.009-.028.009-.044a1.011,1.011,0,0,0-.076-.383.988.988,0,0,0-.217-.326l-2-2a1,1,0,0,0-1.417,1.417l.284.284h-.551A9.52,9.52,0,1,1,85,87.525a1,1,0,0,0,2,0A11.538,11.538,0,0,0,75.48,76Z",
    transform: "translate(-55.938 -27.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M205.011,220a1,1,0,0,0-1,1v1h-2v-1a1,1,0,0,0-2,0v4.009a1,1,0,1,0,2,0v-1h2v1a1,1,0,0,0,2,0V221A1,1,0,0,0,205.011,220Z",
    transform: "translate(-174.946 -153.953)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgent);
export default __webpack_public_path__ + "static/media/urgent.27b7ceca95263760268f73e694370a67.svg";
export { ForwardRef as ReactComponent };